class WishlistError extends Error {
  constructor(message: string | number) {
    super(`${message}`);
    Object.setPrototypeOf(this, WishlistError.prototype);
  }
}

export class WishlistLoadError extends WishlistError {
  constructor(message: string | number) {
    super(message);
    this.name = 'WishlistLoadError';
  }
}

export class AddToWishlistError extends WishlistError {
  constructor(message: string | number) {
    super(message);
    this.name = 'AddToWishlistError';
  }
}

export class RemoveFromWishlistError extends WishlistError {
  constructor(message: string | number) {
    super(message);
    this.name = 'RemoveFromWishlistError';
  }
}
